import { getToken } from './helper'

const sanitizeFilename = (name) => {
  const n = (name || 'download').toString().trim()
  return n.replace(/[\/\\?%*:|"<>]/g, '_')
}

const parseFilenameFromDisposition = (disp) => {
  if (!disp) return ''

  const mStar = /filename\*\s*=\s*([^;]+)/i.exec(disp)
  if (mStar && mStar[1]) {
    let v = mStar[1].trim()
    v = v.replace(/^UTF-8''/i, '')
    v = v.replace(/^["']|["']$/g, '')
    try {
      return decodeURIComponent(v)
    } catch {
      return v
    }
  }

  const m = /filename\s*=\s*([^;]+)/i.exec(disp)
  if (m && m[1]) {
    let v = m[1].trim()
    v = v.replace(/^["']|["']$/g, '')
    return v
  }

  return ''
}

export async function downloadFileByUrls(urls, fallbackName) {
  // ⚠️ SỬA CHỖ NÀY
  const token = await getToken()

  const headers = new Headers()
  if (token) {
    // Viết hoa B cho chuẩn, nhưng hoa/thường đều được
    headers.append('Authorization', `Bearer ${token}`)
  }
  headers.append('Accept', '*/*')

  let lastErr = null

  for (const url of urls) {
    try {
      const res = await fetch(url, { method: 'GET', headers })

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`)
      }

      const blob = await res.blob()

      const disp = res.headers.get('content-disposition') || ''
      const nameFromHeader = parseFilenameFromDisposition(disp)
      const filename = sanitizeFilename(nameFromHeader || fallbackName)

      const blobUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = blobUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(blobUrl)

      return
    } catch (e) {
      lastErr = e
    }
  }

  throw lastErr || new Error('Download failed')
}
